import React from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = (scrollRef) => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pathname, scrollRef]);
};
